import React from 'react';
import { COLOR_HEX, COLOR_HEX_DARK } from './ludoBoard.js';
import { getTokenImage } from './tokenImages.js';

export default function Token({
  color,
  row,
  col,
  cellSize,
  isMovable,
  onClick,
  small = false,
  justLanded = false,
  isAnimating = false,
}) {
  const imageSrc = getTokenImage(color);
  const useImage = Boolean(imageSrc);
  const sizeScale = useImage
    ? (small ? 1.05 : 1.55)
    : (small ? 0.55 : 0.72);
  const diameter = cellSize * sizeScale;
  const inset = (cellSize - diameter) / 2;

  return (
    <button
      type="button"
      className={[
        'ludo-token',
        useImage ? 'ludo-token--image' : '',
        isMovable ? 'ludo-token-movable' : '',
        small ? 'ludo-token-small' : '',
        justLanded ? 'ludo-token-landed' : '',
        isAnimating ? 'ludo-token-animating' : '',
      ].filter(Boolean).join(' ')}
      style={{
        left: `${col * cellSize + inset}%`,
        top: `${row * cellSize + inset}%`,
        width: `${diameter}%`,
        height: `${diameter}%`,
        ...(useImage
          ? {}
          : {
              background: COLOR_HEX[color],
              borderColor: COLOR_HEX_DARK[color],
            }),
      }}
      onClick={onClick}
      disabled={!isMovable}
      aria-label={`${color} token`}
    >
      {useImage && (
        <img
          src={imageSrc}
          alt=""
          className="ludo-token__img"
          draggable={false}
        />
      )}
    </button>
  );
}
